import produce from 'immer';

// TYPES
import { Types, AtualizarTipos } from './types';
import { ReducerAction } from '../../../../../../types';

export const INITIAL_STATE: AtualizarTipos = {
	status: 0,
	data: null,
};

export default function atualizarStatusReducer(
	state = INITIAL_STATE,
	action: ReducerAction,
): AtualizarTipos {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ATUALIZAR_TIPOS: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.ATUALIZAR_TIPOS_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.ATUALIZAR_TIPOS_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.ATUALIZAR_TIPOS_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
